import { Link } from "react-router-dom"

export default function SeeMore() {
  return (
    <Link to={`/portfolio`}>
    <div className="seeMore">more..?</div>
    </Link>
  )
}
